import { gql } from "@apollo/client"

export const getAllAgeGroupMasterQuery = gql`
  query getAgeGroups(
    $searchString: String
    $pageNumber: Float
    $pageLimit: Float
  ) {
    getAllAgeGroupMasters(
      searchString: $searchString
      pageNumber: $pageNumber
      pageLimit: $pageLimit
    ) {
      items {
        id
        lowerAgeLimit
        upperAgeLimit
        ageGroupTitle
        error {
          statusCode
          message
        }
      }
      pagination {
        pageNumber
        pageLimit
        totalCount
      }
    }
  }
`
export const deleteAgeGroupMasterMutation = gql`
  mutation deleteAgeGroup($id: Int!) {
    deleteOneAgeGroupMaster(id: $id) {
      id
      status
      error {
        message
      }
    }
  }
`
export const getOneAgeGroupMasterQuery = gql`
  query getAgeGroupMaster($id: Int!) {
    getOneAgeGroupMaster(id: $id) {
      id
      ageGroupTitle
      upperAgeLimit
    }
  }
`
export const createAgeGroupMasterMutation = gql`
  mutation createAgeGroup($data: ageGroupMasterInput) {
    createOneAgeGroupMaster(data: $data) {
      id
      status
      error {
        message
      }
    }
  }
`
export const updateAgeGroupMasterMutation = gql`
  mutation updateAgeGroup($id: Int!, $data: ageGroupMasterInput) {
    updateOneAgeGroupMaster(id: $id, data: $data) {
      id
      status
      error {
        message
      }
    }
  }
`
